import { Field, useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { Filter } from "../../models/Filter";
import { IAppState } from "../../store/types";
import { appendFilter } from "../../utilities/filters";
import { requiredValidation, validateItemName } from "../../utilities/Validation";
import EntityHierarchy from "../entityHierarchy/entityHierarchy";
import Input from "../input/input";
import Label from "../label/label";
import SettingSelectField, { SelectType } from "../settingFields/SettingSelectField";

export const PermisssionCard: FC = () => {
    const formikContext = useFormikContext<any>();
    const { translate } = useLocale();
    const site = useSelector((state: IAppState) => state.site.site.label)
    const siteId = useSelector((state: IAppState) => state.site.site.value);
    const [filters, setFilters] = useState<Filter[]>(new Array(0));
    const [clearSelectedOption, setClearSelectedOption] = useState(false);

    useEffect(() => {
        setFilters(appendFilter(!formikContext.values.siteId ? siteId : formikContext.values.siteId, "Site", "site.id", []));
    }, [formikContext.values, siteId]);

    useEffect(() => {
        setClearSelectedOption(true);
    }, [siteId])

    useEffect(() => {
        setFilters(appendFilter(siteId, "Site", "site.id", []));
    }, []);

    return <div className="w-full p-2 inline-flex justify-start bg-white">
        {formikContext.values.id
            ? <div className="flex flex-col ml-8 mr-5 py-6">
                <EntityHierarchy title={formikContext.values.name} tree={{ label: formikContext.values.site, node: { label: formikContext.values.name } }} />
            </div>
            : null}
        <div className="flex flex-col py-4 px-8">
            <div className={`mb-2 ${formikContext.values.id ? null : 'pr-6'}`}>
                <div className="flex flex-row justify-between" id='nameLabelId'>
                    <Label
                        htmlFor="name"
                        className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.name)}:</Label>
                    {formikContext.errors.name ? <span className='text-red-600 text-xs'>{formikContext.errors.name}</span> : null}
                </div>
                <Field id='nameInputFieldId'
                    type="text"
                    name="name"
                    disabled={formikContext.values.id && formikContext.values.templateKey !== 1}
                    className={`flex flex-row items-center pr-2 pl-2 p-1 w-full ${formikContext.values.id && formikContext.values.templateKey !== 1 ? 'cursor-not-allowed text-gray-500' : 'text-gray-800'} text-sm bg-gray-input`}
                    validate={(value) => requiredValidation(value, translate)} />
            </div>
            <span id='pInheritsFromDropDownBtn'>
                {formikContext.values.pInheritsFrom ? <div className="flex flex-row justify-between">
                    <Label
                        htmlFor="pInheritsFrom"
                        required
                        className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.copyOf)}:</Label>
                </div> : null }
                {formikContext.values.id ?
                    formikContext.values.pInheritsFrom ? <Field
                        type="text"
                        name="pInheritsFrom"
                        disabled={true}
                        className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" /> : null :
                    <SettingSelectField
                        accessor={"pInheritsFrom"}
                        selectType={SelectType.permissions}
                        setClearSelectedOption={setClearSelectedOption}
                        clearSelectedOption={clearSelectedOption}
                        disabled={formikContext.values.id}
                        required>
                    </SettingSelectField>}
            </span>
        </div>
        <div className="flex flex-col py-4 px-8">
            <div className="flex flex-row justify-between">
                <Label
                    htmlFor="site"
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.site)}:</Label>
            </div>
            {formikContext.values.id
                ? <Field
                    type="text"
                    name="site"
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />
                : <Field
                    type="text"
                    value={site}
                    disabled={true}
                    className="flex flex-row items-center pr-2 pl-2 p-1 text-gray-500 text-sm bg-gray-input w-full cursor-not-allowed" />}
        </div>
    </div>
}
